import { MrbBaseEditViewStore } from "mrb/core";
import { MrbFieldSelectStore } from "mrb/components/select";
import { AdminCertifiedModeEditForm } from "administration/certified-mode/forms";
import { makeObservable } from "mobx";
import { map } from "lodash";

class AdminCertifiedModeEditViewStore extends MrbBaseEditViewStore {
    constructor(rootStore, { routeStore }) {
        const id = rootStore.routerStore.routerState.params.id;
        super(rootStore, {
            id: id,
            name: "certified-mode",
            FormClass: AdminCertifiedModeEditForm,
            autoFocusField: "name",
            navigateBack: "master.administration.certified-mode.list",
            successCreateNotification: null,
            successUpdateNotification: null,
        });
        makeObservable(this);
        this.routeStore = routeStore;

        this.certifierSelectStore = new MrbFieldSelectStore(
            {
                isSearchable: true,
                isMulti: true,
                initFetch: false,
                placeholder: "ADMINISTRATION.CERTIFIED_MODE.EDIT.FIELDS.CERTIFIERS_PLACEHOLDER",
                actions: {
                    find: (searchTerm, page, rpp) => {
                        return this.routeStore.findUsers({
                            searchQuery: searchTerm,
                            page: page,
                            rpp: rpp,
                        });
                    },
                    mapItem: (user) => ({
                        value: user.id,
                        label: `${user.firstName || ""} ${user.lastName || ""} (${user.email ? `(${user.email})` : ""})`,
                        item: user,
                    }),
                },
            },
            this.form.$("certifierUserIds")
        );
    }

    get(id) {
        return this.routeStore.getCertifiedMode(id);
    }

    setItem(item) {
        super.setItem(item);
        if (item.certifiers && item.certifiers.length > 0) {
            this.certifierSelectStore.setSelectedItem(
                map(item.certifiers, (certifier) => certifier.user)
            );
        }
    }

    updateForm(values) {
        this.form.set({
            ...values,
            certifierUserIds: values.certifiers ? map(values.certifiers, (c) => c.userId) : [],
        });
    }

    resetForm() {
        this.form.set({
            isActive: true,
        });
    }

    create(data) {
        if (data.certifierUserIds) {
            data.certifierUserIds = map(data.certifierUserIds, (c) => c.value || c);
        }
        return this.routeStore.createCertifiedMode(data);
    }

    async update(data) {
        if (data.certifierUserIds) {
            data.certifierUserIds = map(data.certifierUserIds, (c) => c.value || c);
        }
        await this.routeStore.updateCertifiedMode(data);
    }

    onCreateError(err) {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to create certified mode.",
            err
        );
    }

    onUpdateError(err) {
        this.rootStore.notificationStore.error(
            "An unexpected error occurred while trying to update certified mode.",
            err
        );
    }
}

export default AdminCertifiedModeEditViewStore;
